import React, { useEffect, useState } from "react";
import Price from "./Price";
import sameIcon from "../../assets/triangle_same.png";
import upIcon from "../../assets/triangle_up.png";
import downIcon from "../../assets/triangle_down.png";

function RankTriangle({ diff: rawDiff, unit }) {
  const [diff, setDiff] = useState(0);
  const [change, setChange] = useState("same");

  useEffect(() => {
    if (rawDiff > 0) {
      setDiff(rawDiff);
      setChange("up");
    } else if (rawDiff < 0) {
      setDiff(Math.abs(rawDiff));
      setChange("down");
    } else {
      setDiff(0);
      setChange("same");
    }
  }, [rawDiff]);

  const iconMap = { up: upIcon, down: downIcon, same: sameIcon };
  const colorMap = {
    up: "text-red-500",
    down: "text-blue-500",
    same: "text-gray-500",
  };

  return (
    <div className="w-full flex items-center justify-center">
      {diff === 0 ? (
        <span className={`flex items-center ${colorMap[change]}`}>
          <p className="text-[6vw] m-0">-</p>
        </span>
      ) : (
        <>
          <span
            className="w-[20px] h-[20px] mr-[1vw] bg-no-repeat bg-center [background-size:80%]"
            style={{ backgroundImage: `url(${iconMap[change]})` }}
          />
          <span
            className={`flex font-bold text-[4vw] text-left ${colorMap[change]}`}
          >
            <Price value={diff} unit={unit} />
          </span>
        </>
      )}
    </div>
  );
}

export default RankTriangle;
